import { render, staticRenderFns } from "./ExpansionTextPanel.vue?vue&type=template&id=05c64d99&scoped=true&"
import script from "./ExpansionTextPanel.vue?vue&type=script&lang=js&"
export * from "./ExpansionTextPanel.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionTextPanel.vue?vue&type=style&index=0&id=05c64d99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c64d99",
  null
  
)

export default component.exports